import { ANY_ZONE, Place, PricingData, Route, WithId, Zone } from "../../lib/pricing";
import { SelectOption, SelectOptionGroup } from "../components/pricing/fields";

/** Valor codificado do select de ponta: "*", "zone:<id>" ou "place:<id>". */
export type EndpointValue = string;

export interface EndpointFields {
  zoneId: string;
  placeId?: string;
}

export const encodeEndpoint = (zoneId: string, placeId?: string): EndpointValue =>
  placeId ? `place:${placeId}` : zoneId === ANY_ZONE ? ANY_ZONE : `zone:${zoneId}`;

/** Converte o valor do select nos campos gravados na tarifa. */
export const decodeEndpoint = (value: EndpointValue, places: Record<string, Place>): EndpointFields => {
  if (value.startsWith("place:")) {
    const placeId = value.slice("place:".length);
    return { zoneId: places[placeId]?.zoneId ?? "", placeId };
  }
  if (value.startsWith("zone:")) return { zoneId: value.slice("zone:".length) };
  return { zoneId: ANY_ZONE };
};

export const endpointGroups = (
  zones: WithId<Zone>[],
  places: WithId<Place>[],
  zoneNames: Record<string, string>
): SelectOptionGroup[] => [
  { label: "Regiões", options: zones.map((z) => ({ value: `zone:${z.id}`, label: z.name })) },
  {
    label: "Locais",
    options: places.map((p) => ({
      value: `place:${p.id}`,
      label: p.name,
      description: zoneNames[p.zoneId],
    })),
  },
];

export const ANY_OPTION: SelectOption = { value: ANY_ZONE, label: "Qualquer origem" };

export interface EndpointLabel {
  name: string;
  detail?: string;
  kind: "any" | "zone" | "place";
}

/** Nome legível de uma ponta da tarifa para listas e resumos. */
export const describeEndpoint = (
  data: PricingData,
  zoneId: string,
  placeId: string | undefined
): EndpointLabel => {
  if (placeId) {
    const place = data.places[placeId];
    return {
      kind: "place",
      name: place?.name ?? "Local removido",
      detail: place ? data.zones[place.zoneId]?.name : undefined,
    };
  }
  if (zoneId === ANY_ZONE) return { kind: "any", name: "Qualquer origem" };
  return { kind: "zone", name: data.zones[zoneId]?.name ?? "Região removida" };
};

export const describeRoute = (data: PricingData, route: Route) => ({
  origin: describeEndpoint(data, route.originZoneId, route.originPlaceId),
  destination: describeEndpoint(data, route.destinationZoneId, route.destinationPlaceId),
});
